module.exports = __webpack_public_path__ + "img/affordacare-advantage-care.372c3ef4.png";